<template>
  <el-form
    ref="documentFormRef"
    :model="documentForm"
    label-width="12ch"
    label-position="left"
    require-asterisk-position="right">
    <!-- Software -->
    <el-form-item
      :label="i18n.t('drawers.documentUploadDrawer.form.software.label')"
      prop="software_id"
      data-tutorial-id="documents-add-software-input">
      <el-select-v2
        v-model="documentForm.software_id"
        :options="selectApplicationOptions"
        :placeholder="
          i18n.t('drawers.documentUploadDrawer.form.software.placeholder')
        ">
        <template #default="{ item }">
          <div style="display: flex; align-items: center; gap: 10px">
            <ApplicationIcon :application-name="item.label" />
            <span>{{ item.label }}</span>
          </div>
        </template>
      </el-select-v2>
    </el-form-item>

    <!-- Title -->
    <el-form-item
      :label="i18n.t('drawers.documentUploadDrawer.form.name.label')"
      data-tutorial-id="documents-add-name-input">
      <el-input
        v-model="documentForm.title"
        :placeholder="
          i18n.t('drawers.documentUploadDrawer.form.name.placeholder')
        " />
    </el-form-item>
    <!-- Date -->
    <el-form-item
      :label="i18n.t('drawers.documentUploadDrawer.form.date.label')"
      data-tutorial-id="documents-add-date-input">
      <div style="display: flex; flex-direction: column">
        <el-date-picker
          v-model="documentForm.date"
          type="date"
          format="DD.MM.YYYY" />
      </div>
    </el-form-item>
    <!-- Notes -->
    <el-form-item
      :label="i18n.t('drawers.documentUploadDrawer.form.note.label')"
      data-tutorial-id="documents-add-note-input">
      <el-input
        v-model="documentForm.notes"
        :autosize="{ minRows: 5, maxRows: 10 }"
        type="textarea"
        :placeholder="
          i18n.t('drawers.documentUploadDrawer.form.note.placeholder')
        " />
    </el-form-item>
  </el-form>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import {
    DocumentInfo,
    SoftwareMiniOut,
    SoftwareOut,
    SoftwareService,
  } from '@/client'
  import { DocumentForm } from './DocumentUploadDialog.vue'
  import { FormInstance } from 'element-plus/es/components/form'

  const i18n = useI18n()

  interface Props {
    viewMode: boolean
    softwareId?: string | null
  }

  withDefaults(defineProps<Props>(), {
    viewMode: false,
    softwareId: undefined,
  })

  const documentForm = defineModel<DocumentForm | DocumentInfo>(
    'documentForm',
    {
      required: true,
    }
  )

  const documentFormRef = defineModel<FormInstance | undefined>(
    'documentFormRef',
    {
      required: true,
    }
  )

  const applications = ref<SoftwareOut[] | SoftwareMiniOut[]>()
  const selectApplicationOptions = computed(() =>
    applications.value
      ? applications.value?.map((app) => ({
          label: app.display_name || app.software_name,
          value: app._id,
        }))
      : []
  )

  SoftwareService.getSoftwareListApiV1SoftwareSoftwareGet({}).then(
    (response) => (applications.value = response)
  )
</script>

<style scoped>
  .company-mini-img {
    height: 15px;
    width: 15px;
  }
  .helper-text {
    font-weight: 300;
    line-height: 14px;
    font-size: 11px !important;
  }
</style>
